import { Form, Modal } from "antd";
import { useState } from "react";
import styles from "../../../../create/clientsJob.module.scss";
import AddClassCandidate from "../../../../../candidates/addClassCandidate";

export const AddClassCandidateModal = ({
  title,
  open,
  loading,
  onCancel,
  onFinish,
  classId,
  getCandidateUdfs,
  ...props
}) => {
  const [form] = Form.useForm();
  const [isDataLoading, setIsDataLoading] = useState(true);

  return (
    <Modal
      className={`${styles.addNewCandidateModal} s2-theme-style modal-overflow-auto`}
      width={632}
      centered
      destroyOnClose
      closeIcon={<i className={`icon-closeable ${styles.closeAble}`} />}
      title={title}
      open={open}
      onCancel={onCancel}
      onOk={form.submit}
      okButtonProps={{ loading, disabled: isDataLoading }}
      {...props}
    >
      <AddClassCandidate
        styles={styles}
        form={form}
        addCandidateCancel={onCancel}
        getCandidateUdf={getCandidateUdfs}
        isDataLoading={isDataLoading}
        setIsDataLoading={setIsDataLoading}
        classId={classId}
        onFinish={onFinish}
      />
    </Modal>
  );
};
